import styled from "styled-components";

const HolidayCalendarSc = styled.div`
  margin: 10px;
  padding: 5px;
  height: 90vh;
  border-radius: 10px;
  /* fallback for old browsers */
  width: 100vw;
  /* Chrome 10-25, Safari 5.1-6 */
  position: absolute;
  top: 45px;
  table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
    margin: 30px auto;
    max-width: 800px;
    background-color: #fff;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  }

  th {
    background-color: #4285f4;
    color: #fff;
    border: 1px solid #4285f4;
    text-align: center;
    padding: 12px;
  }

  td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
  }

  tr:nth-child(even) {
    background-color: #f2f2f2;
    justify-content: center;
  }

  th:hover {
    background-color: #3367d6;
  }

  tr:hover td {
    background-color: #e4f0fb;
  }
`;

export default HolidayCalendarSc;
